import { AdditionalFilterParameter } from '@bvi/api-interfaces/request/case';

const FALSE_ONLY_PARAMETERS = new Set<string>([
  AdditionalFilterParameter.EXCLUDE_ORGANIZATION,
  AdditionalFilterParameter.EXCLUDE_SUBSIDIARY,
]);

/**
 * Removes parameters that do not change statistics. This lets equivalent
 * default URLs share one RTK/Redis cache path instead of creating cold misses.
 */
export const normalizeStatisticsParameters = (
  parameters: Record<string, unknown>,
) =>
  Object.fromEntries(
    Object.entries(parameters)
      .filter(([key, value]) => {
        if (
          value == null ||
          value === '' ||
          (Array.isArray(value) && value.length === 0)
        ) {
          return false;
        }

        return !(
          FALSE_ONLY_PARAMETERS.has(key) &&
          (value === false || value === 'false')
        );
      })
      .sort(([left], [right]) => left.localeCompare(right)),
  );
